import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledPlatofrmHero = styled.section`
	text-align: center;
	overflow: hidden;
	background: url(/assets/hero-bg.webp);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center 0%;
	color: ${CSSVars.white};

	.hero-wrapper {
		padding: 80px 20px 50px;
		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 130px 40px 100px;
		}

		h1 {
			position: relative;
			z-index: 10;
			font-size: ${CSSVars.fontSize2XL};
			max-width: 750px;
			text-align: left;
			margin: 0px auto 20px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 0px auto 30px;
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize3XL};
			}

			span {
				text-transform: capitalize;
			}
		}

		h2 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSizeLG};
			font-weight: 300;
			max-width: 1200px;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSizeXL};
			}
		}

		.updated-label {
			position: relative;
			z-index: 10;
			margin: 16px 0 0;
			font-size: ${CSSVars.fontSizeSM};
			font-weight: 300;
			opacity: 0.7;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}
		}

		a {
			margin: 30px 0 0;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 50px auto 0;
			}
		}
	}
`;
